import * as React from 'react';
import styled from 'styled-components';
import { ChevronLeft } from '@lendi-ui/icon';
import { Link } from '@lendi-ui/typography';
import { mt } from '@lendi-ui/spacing';
import { gte } from '@lendi-ui/breakpoint';
import getColours from '@lendi-ui/commons/colours';

const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  color: ${() => getColours('interaction', 'main')};
  overflow: hidden;
  text-transform: uppercase;
  text-decoration: none;
  ${mt('xs')};
  ${gte('tablet')`
    ${mt('sm')};
  `};
  && {
  }
`;

export interface BackLinkProps {
  handleClick?: () => void;
}

export const BackLink: React.FunctionComponent<BackLinkProps> = ({ handleClick }) => (
  <StyledLink size="sm" onClick={handleClick} data-testid="back-link">
    <ChevronLeft color={getColours('interaction', 'main')} />
    Back
  </StyledLink>
);
